import { render, staticRenderFns } from "./BuscarEstudo.vue?vue&type=template&id=3459ef08&"
import script from "./BuscarEstudo.vue?vue&type=script&lang=js&"
export * from "./BuscarEstudo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports